import * as $ from 'jquery';

export class Global {

    public static detectTransEndType() {
        var t:any;
        var el:HTMLElement = document.createElement('fakeelement');
        var transitions:any = {
          'transition':'transitionend',
          'OTransition':'oTransitionEnd',
          'MozTransition':'transitionend',
          'WebkitTransition':'webkitTransitionEnd'
        };

        for(t in transitions){
            if( el.style[t] !== undefined ){
                return transitions[t];
            }
        }
    }

    public static newTag(tg:string, cn?:string) {
        let elem = document.createElement(tg);
        if (typeof cn != 'undefined') elem.className = cn;
        return elem;
    }

    public static getViewport() {
        var e:any = window;
        var a:string = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return { width: e[a + 'Width'], height: e[a + 'Height'] };
    }

    public static onScreen($e:JQuery, topOffset?:number) {
        var posTop = $e.offset().top;
        var scrollPos = this.getScrollPosition((typeof topOffset == 'undefined') ? 0: topOffset);
        var h = $e.outerHeight(true);
        return (posTop < (scrollPos + $(window).height()) && (posTop + h) > scrollPos) ? true: false;
    }

    public static getScrollPosition(topOffset:number) {
        if (document.documentElement.scrollTop === 0)
            return document.body.scrollTop + topOffset;
        else
            return document.documentElement.scrollTop + topOffset;
    }

    public static LightenDarkenColor(col:string, amt:number) {
  
        let usePound = false;
      
        if (col[0] == "#") {
            col = col.slice(1);
            usePound = true;
        }
     
        let num = parseInt(col,16);
        let r = (num >> 16) + amt;
     
        if (r > 255) r = 255;
        else if  (r < 0) r = 0;
     
        let b = ((num >> 8) & 0x00FF) + amt;
     
        if (b > 255) b = 255;
        else if  (b < 0) b = 0;
     
        let g = (num & 0x0000FF) + amt;
     
        if (g > 255) g = 255;
        else if (g < 0) g = 0;
     
        return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
      
    }

    public static rgb2hex(rgb:any) {
        rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        return "#" + Global.genHex(rgb[1]) + Global.genHex(rgb[2]) + Global.genHex(rgb[3]);
    }

    public static genHex(x:any) {
        return ('0' + parseInt(x).toString(16)).slice(-2);
    }

    /* Getters / Setters 
    */

    public static get detectTransitionEvent():string {
        return Global.detectTransEndType();
    }
}